import { Box, Button, Paper, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import DataTable from "./DataTable";
import ProductContext from "./context";
import { useProductManager } from "./useProduct";

const Products = () => {
  const navigate = useNavigate();
  return (
    <Paper sx={{ p: 2 }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h5">Produtos</Typography>

        <Button onClick={() => navigate("./create")} variant="contained">
          Registrar
        </Button>
      </Box>
      <DataTable />
    </Paper>
  );
};

const Index = () => {
  return (
    <ProductContext.Provider value={useProductManager()}>
      <Products />
    </ProductContext.Provider>
  );
};

export default React.memo(Index);
